const env = process.env || {}; // eslint-disable-line no-process-env

[
  'NODE_ENV',
  'APP_PORT',
  'API_URL'
].forEach((name) => {
  if (!env[name]) {
    console.log(`Environment variable ${name} is missing, use default instead.`);
  }
});

const config = {
  ENV: env.NODE_ENV || 'development',
  staticURL: env.STATIC_URL || 'http://localhost:3001',
  APP_URL: 'https://trienlam.phuyentrade.gov.vn/',
  API_URL: 'https://api.trienlam.phuyentrade.gov.vn/api/',
  API_VITRADE_URL: 'https://api.phuyentrade.gov.vn/api/',
  PORT: Number(env.APP_PORT || 4000),
  UploadImageURL: 'https://img.phuyentrade.gov.vn',
  VITRADE_IMAGE_URL: 'https://img.phuyentrade.gov.vn',

  CAPTCHA_KEY: '6Lf6HnYUAAAAABoPM-48h8vYep56w43NfUwx0cpF',
  FB_ID: '186114358979294'
};


module.exports = config;



// WEBPACK FOOTER //
// ./constants/config.js